<template>
  <div>
    <v-dialog scrollable persistent v-model="dialog">
      <v-card color="background">
        <v-card-title> Dados da Chamada </v-card-title>
        <v-divider />

        <v-card-text>
          <v-sheet v-show="showSkeletonTimeline" class="pa-3">
            <v-skeleton-loader class="mx-auto" type="list-item" height="40" />
            <v-skeleton-loader class="mx-auto" type="list-item" height="40" />
          </v-sheet>

          <TimeLineChamadas v-show="!showSkeletonTimeline" />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-expansion-panels v-model="panel" multiple focusable class="mt-4 mb-14">
      <v-expansion-panel readonly>
        <v-expansion-panel-header hide-actions>
          <div class="text-center font-weight-bold">
            <v-row no-gutters>
              <v-col cols="2" class="text-left">Data</v-col>
              <v-col cols="1" class="text-left">Hora</v-col>
              <v-col cols="2" class="text-left">Cliente</v-col>
              <v-col cols="1" class="text-left">Ramal</v-col>
              <v-col cols="2" class="text-left">Operador</v-col>
              <v-col cols="1" class="text-left">Avaliações</v-col>
              <v-col cols="2" class="text-center" v-if="permissaoVisualizarHistorico">Histórico</v-col>
            </v-row>
          </div>
        </v-expansion-panel-header>
      </v-expansion-panel>

      <v-expansion-panel v-for="(avaliacao, key) in avaliacoes" :key="key">
        <v-expansion-panel-header ripple>
          <v-row no-gutters align="center">
            <v-col cols="2" class="text-left">{{ getData(avaliacao.data) }}</v-col>
            <v-col cols="1" class="text-left pl-1">{{ getHora(avaliacao.data) }}</v-col>
            <v-col cols="2" class="text-left pl-2">{{ avaliacao.cliente }}</v-col>
            <v-col cols="1" class="text-left pl-3">{{ avaliacao.ramal }}</v-col>
            <v-col cols="2" class="text-left pl-3">
              {{
                avaliacao.operador
                  .split(' - ')
                  .reverse()
                  .join(' - ')
              }}
            </v-col>
            <v-col cols="1" class="text-left pl-5">{{
              `${avaliacao.avaliacoes.length}/${avaliacao.quantidadeAvaliacoes}`
            }}</v-col>

            <v-col cols="2" class="text-center ml-5 pb-n2" v-if="permissaoVisualizarHistorico">
              <v-btn dark small icon color="bluePcm" @click.native.stop="verChamada(avaliacao.linkedid)">
                <v-icon>mdi-information-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <template v-slot:actions>
            <v-icon color="orangePcm">$expand</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content color="background">
          <TimeLineAvaliacoes :avaliacoes="avaliacao.avaliacoes" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import relatorioDetalhadoPesquisaSatisfacaoStore from '../_store'

import TimeLineAvaliacoes from './TimeLineAvaliacoes'
import TimeLineChamadas from './TimeLineChamadas'

export default {
  name: 'ExpansionListOperadorDireto',
  components: { TimeLineAvaliacoes, TimeLineChamadas },
  props: {
    avaliacoes: Array,
  },
  data: () => ({
    panel: [],
    dialog: false,
    showSkeletonTimeline: true,
    dadosChamadaPabx: {},
    permissaoVisualizarHistorico: false,
    arrayPermissionsHistorico: [
      process.env.VUE_APP_ADMINISTRADOR,
      process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_TOTAL,
      process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_OUVIR_GRAVACAO_HISTORICO,
      process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_HISTORICO,
    ],
  }),
  computed: {
    ...mapGetters('ExpansionListRelatorioDetalhadoPesquisaSatisfacaoStore', ['getDadosChamada']),
  },

  created() {
    registerVuexModule(
      this.$store,
      'ExpansionListRelatorioDetalhadoPesquisaSatisfacaoStore',
      relatorioDetalhadoPesquisaSatisfacaoStore
    )

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    arrayPermissions.forEach(permissionLocalStorage => {
      if (this.arrayPermissionsHistorico.includes(permissionLocalStorage)) {
        this.permissaoVisualizarHistorico = true
      }
    })
  },

  methods: {
    ...mapActions('ExpansionListRelatorioDetalhadoPesquisaSatisfacaoStore', ['gerarDadosChamada']),
    ...obtainUserPermissions,

    getData(dataHora) {
      return moment(dataHora, 'DD-MM-YYYY HH:mm').format('DD/MM/YYYY')
    },
    getHora(dataHora) {
      return moment(dataHora, 'DD-MM-YYYY HH:mm').format('HH:mm')
    },
    async verChamada(linkedid) {
      this.showSkeletonTimeline = true
      this.dialog = true
      await this.gerarDadosChamada(linkedid)
      this.showSkeletonTimeline = false
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
